import { Component, Inject, HostListener } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-company-filter-dialog',
  templateUrl: './company-filter-dialog.component.html',
  styleUrls: ['./company-filter-dialog.component.scss']
})
export class CompanyFilterDialogComponent {
  filters: any;
  companyType: any[];
  isDropdownOpen: boolean = false;
  companyTypeOptions: Array<{ label: string; value: string }> = [];

  constructor(
    public dialogRef: MatDialogRef<CompanyFilterDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.filters = { ...data.filters };
    this.companyType = data.companyType || [];
    this.companyTypeOptions = this.companyType.map((option: any) => ({
      label: option.value,
      value: option.key
    }));
    
    // Initialize company type if not set
    if (!this.filters.company_type) {
      this.filters.company_type = '';
    }
    // Ensure name exists
    if (this.filters.name === undefined || this.filters.name === null) {
      this.filters.name = '';
    }
  }

  // Custom dropdown methods
  toggleDropdown(): void {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  selectOption(option: any): void {
    this.filters.company_type = option.value;
    this.isDropdownOpen = false;
  }

  getSelectedLabel(): string {
    const selected = this.companyTypeOptions.find(opt => opt.value === this.filters.company_type);
    return selected ? selected.label : '';
  }

  // Handle escape key press
  @HostListener('document:keydown.escape', ['$event'])
  handleEscapeKey(event: KeyboardEvent): void {
    this.close();
  }

  // Handle clicking outside the dialog
  onOverlayClick(event: MouseEvent): void {
    // Only close if clicking directly on the overlay, not on dialog content
    if (event.target === event.currentTarget) {
      this.close();
    }
    // Close dropdown when clicking outside
    this.isDropdownOpen = false;
  }

  applyFilters(): void {
    this.dialogRef.close(this.filters);
  }

  clearFilters(): void {
    this.filters = { name: '', company_type: '' };
    this.dialogRef.close(this.filters);
  }

  close(): void {
    this.dialogRef.close();
  }
}
